import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Phone, CheckCircle2, Sparkles, ChevronLeft, ChevronRight, Maximize2 } from 'lucide-react';
import { fetchCollection } from '../../lib/cms';
import GalleryModal from '../../components/GalleryModal';
import SEO from '../../components/SEO';

export default function ProduktDe() {
  const [galleryImages, setGalleryImages] = useState([]);
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [galleryIndex, setGalleryIndex] = useState(0);
  const [activeImageIndex, setActiveImageIndex] = useState(0);

  const productImages = [
    {
      url: 'https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/danshaker-3-farver.png',
      alt: 'Danshaker Sortiermaschine - In zahlreichen Farben erhältlich',
      caption: 'Wählen Sie frei Ihre Lieblingsfarbe – das Bild zeigt nur einen kleinen Auszug der vielen Optionen'
    },
    {
      url: 'https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/c4a731ab-6721-435d-8de5-d6368af70f19.jpg',
      alt: 'Danshaker Entmistungsmaschine - Zubehörhalterung',
      caption: 'Werkzeughalterung für Rechen und Mistgabel als Sonderzubehör'
    },
    {
      url: 'https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/8dbd0056-687d-4231-9ce4-f8f186646ff9.jpg',
      alt: 'Danshaker mit Gummibremse und schwarzen Rädern',
      caption: 'Danshaker Gummibremse und robuste schwarze Vorderräder'
    },
    {
      url: 'https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/80ade798-7838-4838-ba9d-88d0e973e725.jpg',
      alt: 'Danshaker Entmistungsmaschine - Kompakte Bauweise',
      caption: 'Kompaktes und ergonomisches Design für enge Stallgassen'
    },
    {
      url: 'https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/e78bab06-df3e-49dd-b2cd-e5a4891479a9.jpg',
      alt: 'Danshaker Sortiermaschine - Robuste dänische Qualität',
      caption: 'Dänische Qualität gefertigt für das anspruchsvolle Stallumfeld'
    },
    {
      url: 'https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/a91119ee-cb50-4bb0-8636-9ff6a6aa87e2.jpg',
      alt: 'Danshaker in individueller Sonderlackierung',
      caption: 'Lust auf auffällige Farben? Wir lackieren in jedem gewünschten RAL-Farbton'
    },
    {
      url: 'https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/735ab98a-19ad-4a44-8706-12f21749ddce.jpg',
      alt: 'Danshaker Entmistungsmaschine - Schnelle Entleerung',
      caption: 'Einfaches Entleeren und minimaler Verlust von sauberer Einstreu'
    }
  ];

  useEffect(() => {
    async function loadData() {
      const galleriData = await fetchCollection('galleri', 'de');
      if (galleriData && galleriData.length > 0) {
        setGalleryImages(galleriData[0].images || []);
      }
    }
    loadData();
  }, []);

  const openGallery = (index) => {
    setGalleryIndex(index);
    setIsGalleryOpen(true);
  };

  const nextImage = (e) => {
    e.stopPropagation();
    setActiveImageIndex((prev) => (prev + 1) % productImages.length);
  };

  const prevImage = (e) => {
    e.stopPropagation();
    setActiveImageIndex((prev) => (prev - 1 + productImages.length) % productImages.length);
  };

  const wusstenSieSchon = [
    'Der Danshaker läuft mit einem wiederaufladbaren Akku und schafft bis zu 86 Boxen à 10 Minuten pro Ladung.',
    'Die Maschine ist extrem wendig, kinderleicht zu bedienen und im Waschplatz schnell gereinigt.',
    'Der Danshaker wird komplett in Dänemark aus langlebigen Qualitätswerkstoffen konstruiert und hergestellt.',
    'Umfangreiches Zubehör wie Schubkarrenhalterung oder Seitenrutsche lässt sich jederzeit nachrüsten.',
    'Wählen Sie Ihre persönliche Wunschfarbe für den Danshaker – in allen RAL-Tönen lieferbar.',
    'Auf Wunsch veredeln wir die Lackierung mit exklusiven Glitzerpartikeln gegen geringen Aufpreis.'
  ];

  const trin = [
    {
      img: 'https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/82c2389c-2509-456f-8e9c-aa5c44a15f3e.jpg',
      title: 'Einstreu aufschaufeln',
      desc: '– schnell und ohne Kraftaufwand'
    },
    {
      img: 'https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/69ce56ce-163d-4516-8f4f-6b6ab388a8f4.jpg',
      title: 'Danshaker rüttelt durch',
      desc: '– saubere Einstreu wird sekundenschnell getrennt'
    },
    {
      img: 'https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/6043796d-21d0-49bc-ab4e-1aa2283c1f84.jpg',
      title: 'Saubere Einstreu wiederverwenden',
      desc: '– nur Mist und Kot entsorgen'
    }
  ];

  const productSchema = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: 'Danshaker Sortiermaschine',
    image: 'https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/danshaker-3-farver.png',
    description: 'Ergonomische und akkubetriebene Entmistungs- und Sortiermaschine für Pferdeställe. Trennt saubere Einstreu von Kot.',
    brand: {
      '@type': 'Brand',
      name: 'Danshaker',
    },
    offers: {
      '@type': 'Offer',
      priceCurrency: 'EUR',
      price: '4225',
      availability: 'https://schema.org/InStock',
      url: 'https://danshaker.dk/de/produkt',
    },
  };

  return (
    <div className="relative min-h-screen bg-slate-50 text-slate-900 antialiased">
      <SEO
        title="Danshaker Entmistungs- & Sortiermaschine für Pferdeställe"
        description="Danshaker ist die originale dänische Entmistungsmaschine für Pferdeboxen. Akkubetrieben, ergonomisch, spart bis zu 50% Einstreu und halbiert die Arbeitszeit."
        path="/de/produkt"
        lang="de"
        schema={productSchema}
      />

      {/* Background gradients */}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(14,103,162,0.05),transparent_60%)]" />

      {/* Top Product Presentation */}
      <section className="mx-auto max-w-7xl px-4 pt-12 pb-16 md:px-8 md:pt-16">
        <div className="grid gap-12 lg:grid-cols-12 lg:items-start">
          {/* Visual Gallery */}
          <div className="lg:col-span-6 space-y-4">
            <div 
              className="relative aspect-4/3 overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-xl cursor-pointer group"
              onClick={() => openGallery(activeImageIndex)}
            >
              <img
                src={productImages[activeImageIndex].url}
                alt={productImages[activeImageIndex].alt}
                width="700"
                height="525"
                fetchPriority="high"
                decoding="async"
                className="h-full w-full object-cover transition duration-300 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-slate-950/10 opacity-0 group-hover:opacity-100 transition flex items-center justify-center">
                <span className="flex items-center gap-1.5 rounded-xl bg-white/95 px-4 py-2 text-xs font-bold text-slate-900 shadow-md">
                  <Maximize2 className="h-4 w-4" />
                  Großansicht öffnen
                </span>
              </div>

              {/* Prev/Next arrows */}
              <button
                onClick={prevImage}
                className="absolute left-4 top-1/2 -translate-y-1/2 p-2 rounded-full bg-white/90 text-slate-800 shadow-md hover:bg-white transition cursor-pointer"
                aria-label="Vorheriges Bild"
              >
                <ChevronLeft className="h-5 w-5" />
              </button>
              <button
                onClick={nextImage}
                className="absolute right-4 top-1/2 -translate-y-1/2 p-2 rounded-full bg-white/90 text-slate-800 shadow-md hover:bg-white transition cursor-pointer"
                aria-label="Nächstes Bild"
              >
                <ChevronRight className="h-5 w-5" />
              </button>

              <div className="absolute bottom-4 left-4 right-4 rounded-xl bg-black/60 backdrop-blur-xs p-2.5 text-center text-xs text-white">
                {productImages[activeImageIndex].caption}
              </div>
            </div>

            {/* Thumbnail selector */}
            <div className="grid grid-cols-4 sm:grid-cols-7 gap-2">
              {productImages.map((img, idx) => (
                <button
                  key={idx}
                  onClick={() => setActiveImageIndex(idx)}
                  className={`relative aspect-square overflow-hidden rounded-xl border-2 transition ${
                    idx === activeImageIndex ? 'border-[#0E67A2] scale-105 shadow-md' : 'border-slate-200 opacity-70 hover:opacity-100'
                  }`}
                >
                  <img
                    src={img.url}
                    alt={img.alt}
                    width="120"
                    height="120"
                    loading="lazy"
                    decoding="async"
                    className="h-16 w-full object-cover"
                  />
                </button>
              ))}
            </div>
          </div>

          {/* Product Details & Specs */}
          <div className="lg:col-span-6 space-y-6">
            <div>
              <div className="inline-flex items-center gap-2 rounded-full border border-[#0E67A2]/20 bg-[#0E67A2]/5 px-4 py-1.5 text-xs font-bold text-[#0E67A2] mb-3">
                <Sparkles className="h-3.5 w-3.5" aria-hidden="true" />
                <span>Die originale dänische Entmistungsmaschine</span>
              </div>
              <h1 className="text-3xl font-extrabold text-slate-900 sm:text-4xl">
                Danshaker Sortiermaschine
              </h1>
              <p className="mt-2 text-[#0E67A2] font-black text-lg">
                Effiziente, rückenschonende und wirtschaftliche Stallrevolution
              </p>
            </div>

            <p className="text-slate-700 leading-relaxed font-medium">
              Der Danshaker wurde speziell für Pferdeställe entwickelt, um die schwere manuelle Mistarbeit abzulösen. Die Maschine rüttelt automatisch die saubere Einstreu frei und fängt Pferdeäpfel und Kot im Behälter auf.
            </p>

            <p className="text-slate-700 leading-relaxed font-medium">
              Die Bodenfreiheit der Maschine beträgt 69 cm, sodass eine handelsübliche Schubkarre bequem darunter passt.
            </p>

            {/* Price & Primary CTA */}
            <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm space-y-4">
              <div className="flex flex-wrap items-baseline justify-between gap-2 border-b border-slate-100 pb-4">
                <div>
                  <span className="text-xs font-bold uppercase tracking-wider text-slate-400">Unverbindlicher Richtpreis</span>
                  <div className="text-3xl font-black text-slate-900">
                    Angebot anfordern
                  </div>
                </div>
                <span className="text-xs font-bold text-[#0E67A2] bg-[#0E67A2]/10 px-3 py-1 rounded-full">
                  Leasing & Miete möglich
                </span>
              </div>

              <div className="flex flex-col sm:flex-row gap-3 pt-2">
                <Link
                  to="/de/kostenlose-demo"
                  className="flex-1 flex items-center justify-center gap-2 rounded-xl bg-[#0E67A2] px-6 py-3.5 font-bold text-white shadow-md transition hover:bg-[#0E67A2]/90"
                >
                  <Calendar className="h-5 w-5" aria-hidden="true" />
                  Kostenlose Demo buchen
                </Link>
                <Link
                  to="/de/kontakt"
                  className="flex items-center justify-center gap-2 rounded-xl border border-slate-300 bg-white px-6 py-3.5 font-bold text-slate-800 hover:bg-slate-50 transition"
                >
                  <Phone className="h-4 w-4" />
                  Kontakt
                </Link>
              </div>
            </div>

            {/* Bullet features */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
              <div className="flex items-center gap-2 text-sm font-semibold text-slate-800">
                <CheckCircle2 className="h-5 w-5 text-emerald-600 shrink-0" />
                <span>Bis zu 86 Boxen pro Akkuladung</span>
              </div>
              <div className="flex items-center gap-2 text-sm font-semibold text-slate-800">
                <CheckCircle2 className="h-5 w-5 text-emerald-600 shrink-0" />
                <span>100% kabelloser Akkubetrieb</span>
              </div>
              <div className="flex items-center gap-2 text-sm font-semibold text-slate-800">
                <CheckCircle2 className="h-5 w-5 text-emerald-600 shrink-0" />
                <span>Freie Farbauswahl (alle RAL-Töne)</span>
              </div>
              <div className="flex items-center gap-2 text-sm font-semibold text-slate-800">
                <CheckCircle2 className="h-5 w-5 text-emerald-600 shrink-0" />
                <span>Reinigung in nur 1 Minute</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 3 Steps */}
      <section className="border-t border-slate-300 bg-white py-16">
        <div className="mx-auto max-w-7xl px-4 md:px-8">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <h2 className="text-3xl font-extrabold text-slate-900 md:text-4xl">So einfach ist die Anwendung</h2>
            <p className="mt-4 text-slate-600 font-medium">3 Schritte zu einem schnelleren und saubereren Boxenalltag.</p>
          </div>

          <div className="grid gap-8 md:grid-cols-3">
            {trin.map((item, idx) => (
              <div key={idx} className="rounded-2xl border border-slate-200 bg-slate-50 overflow-hidden shadow-sm">
                <img
                  src={item.img}
                  alt={item.title}
                  width="400"
                  height="260"
                  loading="lazy"
                  decoding="async"
                  className="h-48 w-full object-cover"
                />
                <div className="p-6">
                  <h3 className="font-bold text-slate-900 text-lg mb-1">{item.title}</h3>
                  <p className="text-sm text-slate-600 font-medium">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Wussten Sie schon */}
      <section className="py-16 mx-auto max-w-7xl px-4 md:px-8">
        <div className="rounded-3xl border border-slate-200 bg-gradient-to-br from-white to-slate-100 p-8 md:p-12 shadow-xl">
          <div className="max-w-3xl">
            <h2 className="text-2xl md:text-3xl font-black text-slate-900 mb-6">Wussten Sie schon?</h2>
            <div className="grid gap-4 sm:grid-cols-2">
              {wusstenSieSchon.map((fact, idx) => (
                <div key={idx} className="flex items-start gap-3">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#0E67A2]/10 text-[#0E67A2] text-xs font-bold">
                    ✓
                  </span>
                  <p className="text-sm text-slate-700 font-medium leading-relaxed">{fact}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="border-t border-slate-300 bg-slate-900 py-16 text-white text-center">
        <div className="mx-auto max-w-4xl px-4 space-y-6">
          <h2 className="text-3xl font-extrabold sm:text-4xl">Testen Sie den Danshaker in Ihrem eigenen Stall</h2>
          <p className="text-slate-300 max-w-xl mx-auto text-base">
            Wir besuchen Sie vor Ort und führen die Maschine unverbindlich vor. Überzeugen Sie sich selbst von der enormen Arbeitserleichterung.
          </p>
          <div className="pt-2 flex flex-wrap justify-center gap-4">
            <Link
              to="/de/kostenlose-demo"
              className="rounded-xl bg-[#0E67A2] px-8 py-4 font-bold text-white shadow-lg transition hover:bg-[#0E67A2]/90"
            >
              Kostenlose Demo anfordern
            </Link>
            <Link
              to="/de/zubehoer"
              className="rounded-xl border border-slate-700 bg-slate-800 px-8 py-4 font-bold text-white transition hover:bg-slate-700"
            >
              Zubehör ansehen
            </Link>
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      <GalleryModal
        isOpen={isGalleryOpen}
        images={galleryImages.length > 0 ? galleryImages : productImages.map(p => p.url)}
        currentIndex={galleryIndex}
        onClose={() => setIsGalleryOpen(false)}
        onPrev={() => setGalleryIndex((prev) => (prev - 1 + (galleryImages.length || productImages.length)) % (galleryImages.length || productImages.length))}
        onNext={() => setGalleryIndex((prev) => (prev + 1) % (galleryImages.length || productImages.length))}
      />
    </div>
  );
}
